import React from 'react';
import './MessageSet.scss';

/**
 * A layout wrapper for a set of messages so they are correctly spaced (and handled as one component)
 */
const MessageSet: React.FC<React.PropsWithChildren> = ({ children }) => <div className="MessageSet">{children}</div>;

export { MessageSet };
export default MessageSet;
